<template>
  <v-sheet elevation="2">
    <div class="px-8 py-4">
      <span class="secondary--text font-weight-bold">{{ title }}</span>
    </div>
    <v-divider />
    <div class="content px-8 py-4">
      <div v-show="!editable" class="edit-button">
        <v-btn
          @click="onClickEdit()"
          color="secondary"
          text
          id="idPortalEditar"
        >
          <SvgIcon
            @click="onClickEdit()"
            class="tertiary--text"
            iconType="icon_edit_pen"
          />
          <span class="text-capitalize" v-if="iconText">{{ iconText }}</span>
        </v-btn>
      </div>
      <slot />
    </div>
  </v-sheet>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
export default {
  components: {
    SvgIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    iconText: {
      type: String
    },
    editable: {
      type: Boolean
    }
  },
  methods: {
    onClickEdit() {
      this.$emit('on-click-edit')
    }
  }
}
</script>

<style scoped>
.content {
  position: relative;
}

.edit-button {
  position: sticky;
  top: 10px;
  float: right;
}
</style>
